import {
  INICIALITZAR,
  INTRODUCCIO_OMPLIR_ID_ESPECIE,
  INTRODUCCIO_OMPLIR_ID_OBSERVADOR
} from "../../actions/actionTypes";

const ESTAT_INICIAL = null;

const idEspecie = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INICIALITZAR:
    case INTRODUCCIO_OMPLIR_ID_OBSERVADOR:
      return ESTAT_INICIAL;
    case INTRODUCCIO_OMPLIR_ID_ESPECIE:
      return action.payload;
    default:
      return state;
  }
};

export default idEspecie;

export const getIdEspecie = state => state;
